 $(document).on('click','.frequantly-together',function(){
    var price = 0,compare_price = 0;
console.log("here");
    $('.upssell_product').attr('disabled',true);
  $('input.frequantly-together:checked').each(function () {
    var dataAttr = $(this).val();
   $('.upssell_product[variant-id="'+dataAttr+'"]').attr('disabled',false);
      price=price + parseFloat($(this).attr('data-price'));
      compare_price=compare_price+ parseFloat($(this).attr('data-compare_price'));
  });
   if($('input.frequantly-together:checked').length >0){
          $('.total_price-wrapper').show();
   }else{
     $('.total_price-wrapper').hide();
   }
  $('.total_price .main_price').attr('main-price',price).text(`${price}`);
    $('.total_price .product_price').attr('compare-price',price).text(`₹${compare_price}`);
     if(compare_price>price){
       $('.product_save_price').text(`₹${compare_price-price}`);
      $('.product-tag-wrapper').show();
       $('.total_price .product_price').show();
     }else{ $('.total_price .product_price,.product-tag-wrapper').hide(); }
      var checked_checkbox= $('input.frequantly-together:checked').length;
    var total_checkbox= $('input.frequantly-together').length;
    if(checked_checkbox == total_checkbox){
      $('button.button.secondary-button.cart_button .count_amount').text('All'); 
    }else{
      if(checked_checkbox == 0){
        checked_checkbox= '';
      }
      $('button.button.secondary-button.cart_button .count_amount').text(checked_checkbox); 
    }
      
     });

  const readMoreButton = document.getElementById('toggle-faq1');
  let isExpanded = false;

  if (readMoreButton) {
   
    readMoreButton.addEventListener('click', function() {
      isExpanded = !isExpanded;
      document.querySelectorAll('.extra-faq1').forEach((faq) => {
        faq.classList.toggle('hidden1');
        $('.frequanlty_bought_content.last-product').toggleClass('hide-circle');
      });
      readMoreButton.innerHTML = isExpanded ? '<p class="bottom-text">View Less <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><rect x="0.5" y="-0.5" width="19" height="19" rx="9.5" transform="matrix(1 0 0 -1 0.5 19.2014)" stroke="#808080"></rect><path d="M7 8.7431L10.5 11.6598L14 8.7431" stroke="#808080" stroke-linecap="round"></path> </svg></p>' : ' <p class="bottom-text">View More <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><rect x="0.5" y="-0.5" width="19" height="19" rx="9.5" transform="matrix(1 0 0 -1 0.5 19.2014)" stroke="#808080"></rect><path d="M7 8.7431L10.5 11.6598L14 8.7431" stroke="#808080" stroke-linecap="round"></path></svg></p>';
    });
  }
$(document).on('click','.cart_button',function(){
  $(this).parents('.product__info-wrapper').find('input[name="id"].product-variant-id').attr('disabled','disabled');
  
  // $('.submit_button_cstm_freq').show();
  // setTimeout(function () {$('.submit_button_cstm_freq').hide()},1000);
  
  $('.product-form__submit').trigger('click');
  $('.product-form__submit').removeClass('loading');
  $('.loading__spinner').addClass('hidden');
  $('.product-form__submit').attr('aria-disabled',false)
 $(this).parents('.product__info-wrapper').find('input[name="id"].product-variant-id').removeAttr('disabled');
})



